<template>
  <div class="race-content screen-content">
    <div class="player">
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        @ready="onPlayerReady($event)"
        @ended="onPlayerEnded($event)"
      ></video-player>
    </div>
  </div>
</template>

<script>
import { padStart } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import VideoPlayer from '@nsftx/games-visualization-sdk/src/components/VideoPlayer';
import types from '../store/mutationTypes';

export default {
  name: 'StageRace',
  components: {
    VideoPlayer,
  },

  data() {
    return {
      videosPath: this.$store.state.ui.videosPath,
      playerOptions: {
        width: window.innerWidth,
        height: window.innerHeight,
        autoplay: true,
        loop: false,
        muted: true,
        language: 'en',
        controls: false,
        sources: [
          // TODO: Remove this when all videos finished
          // {
          //   type: 'video/mp4',
          //   src: require('../assets/race-2.mp4'),
          // },
        ],
      },
    };
  },

  computed: {
    ...mapGetters([
      'raceStartTime',
      'videoId',
    ]),
    player() {
      return this.$refs.videoPlayer.player;
    },
  },

  methods: {
    ...mapActions([
      'activateLoader',
    ]),
    onPlayerReady(player) {
      player.currentTime(this.raceStartTime || 0);
    },
    onPlayerEnded() {
      this.activateLoader();
    },
    generateVideoPath() {
      if (this.videoId) {
        this.player.src({
          src: `${this.videosPath}vdr-${padStart(this.videoId, 5, '0')}.mp4`,
          type: 'video/mp4',
        });
      }
    },
  },

  updated() {
    this.generateVideoPath();
  },

  mounted() {
    this.generateVideoPath();
    this.player.currentTime(this.raceStartTime);
  },

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.race-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.content-item {
  position: absolute;
  width: 100%;
  height: 100%;
  line-height: 100vh;
  background: #000;
  color: $primary-text-color;
  font-size: 48px;
  text-align: center;
}
</style>
